export default {
	Slide: 'Tapmaca',
	Puzzle: 'Tapmaca',
	'The puzzle is open!': 'Bulmaca açıqdır!',
	'Congratulations!': 'Təbrik edirik!',
	'You get it': 'alırsınız',
	'You get the task done': 'Tapşırığı yerinə yetirirsən',

	'Show all blocked': 'Hamısının bloklandığını göstərin',

	Author: 'müəllif',
	'Reset filters': 'Filtrləri sıfırlayın',

	Blocked: 'Blok edilib',
	Unlocked: 'Kilidi açıldı',

	Change: 'Dəyişmək',
	'The student is blocked': 'Tələbə bloklanır',
	'The student is blocked with a new price': 'Tələbə yeni qiymətlə bloklanır',
	'To unlock this student, go to the "Restore" section':
		'Bu tələbənin kilidini açmaq üçün "Bərpa" bölməsinə keçin',

	'Block student': 'Tələbəni bloklayın',

	'Before blocking, you can change the price for the student':
		'Bloklamadan əvvəl siz tələbə üçün qiyməti dəyişə bilərsiniz',

	'First month cost': '1 aylıq qiymət',

	'WARNING! After re-saving the task, the students who completed this task will have the puzzle closed and will have to do it again.':
		'XƏBƏRDARLIQ! Tapşırığı yenidən saxladıqdan sonra, bu tapşırığı yerinə yetirən tələbələr tapmacanı bağlayacaqlar və onu yenidən yerinə yetirməli olacaqlar.',

	"You cannot do homework in the student's platform":
		'Tələbə platformasında ev tapşırığı edə bilməzsiniz',

	'Restore the student ?': 'Tələbəni bərpa etmək?',
	'Restore the teacher ?': 'Müəllimi bərpa etmək?',
	'Restore the franchise ?': 'Franchise bərpa edilsin?',

	'Transition to 50': '50-yə keçid',
	'Transition to 100': '100-yə keçid',

	fifty: '50-yə keçid',
	hundred: '100-yə keçid',

	Faces: 'Üzlər',

	Heroes: 'Qəhrəmanlar',
	Clothes: 'Geyim',
	Backgrounds: 'Fonlar',
	Souvenirs: 'Suvenirlər',

	'Coming soon': 'Tezliklə',

	'Wow! Congratulations, you have successfully purchased this product.':
		'Heyrət! Vay! Təbrik edirik, bu məhsulu uğurla aldınız.',
	'You can view all your purchases in the "Purchased" section':
		'Bütün alış-verişlərinizə "Satın alınmışlar" bölməsində baxa bilərsiniz',

	'Your savings': 'Əmanətləriniz',
	'You can spend them on something interesting!':
		'Onları maraqlı bir şeyə xərcləyə bilərsiniz!',

	'A student with this email address already exists':
		'Belə e-poçtu olan istifadəçi artıq mövcuddur',

	'User with such email already exists':
		'Belə e-poçtu olan istifadəçi artıq mövcuddur',
	'Year of birth': 'Doğum ili',
	Registration: 'Qeydiyyat',
	'Surname of parents': 'Valideynlərin soyadı',
	School: 'Məktəb',
	'Field is required': 'Sahə tələb olunur',
	'Select age': 'Yaş seçin',
	'No such teacher for this year': 'Bu il belə müəllim yoxdur',
	'User with such phone number already exists':
		'Belə telefon nömrəsi olan istifadəçi artıq mövcuddur',
	'You are successfully registered': 'Siz uğurla qeydiyyatdan keçmisiniz',
	'Max length 20 chars': 'Max uzunluğu 20 chars',

	'Participate in online Indigo Olympiad':
		'İndiqo Onlayn Olimpiadasında yarışın! ',
	Participate: 'İştirak et',
	export: 'Ixrac',
	wrong: 'Səhvdir',
	right: 'Düzgündür',
	match: {
		addition: 'Forsaj',
		multiply: 'Vurma',
		divide: 'Bölmə',
		abacus_random: 'Abakus random',
		anzan: 'Anzan',
		negative: 'Mənfi ədədlər',
		column: 'Sütunlar',
	},
	timeIsOver: 'Vaxt bitdi',
	timer: 'Taymer',
	'Back to Lessons': 'Geriyə dərslərin siyahısına',
	'Create Lesson': 'Dərs yarat',
	Assign: 'Təyin etmək',
	Home: 'Əsas səhifəyə',
	'To cabinet': 'Kabinetə',
	'Create a homework': 'Ev tapşırığı yarat',
	January: 'Yanvar',
	February: 'Fevral',
	March: 'Mart',
	April: 'Aprel',
	May: 'May',
	June: 'İyun',
	July: 'İyul',
	August: 'Aqvsut',
	'Group nickname': 'Qrupun nik adı',
	September: 'Sentyabr',
	October: 'Oktyabr',
	November: 'Noyabr',
	December: 'Dekabr',
	Overall: 'Ümumi',
	Active: 'Aktiv',
	'Contract number': 'Əlaqə nömrəsi',
	'For parents': 'Valideynlər üçün',
	'Choose lessons': 'Dəsrləri seçin',
	Save: 'Təyin etmək',
	Close: 'Bağlamaq',
	'Change birthday': 'Təvüllüdü dəyişmək',
	Sent: 'Göndərilib',
	'Choose date': 'Tarixi seçin',
	'Include students': 'Tələbələri daxil et',
	'Add service': 'Xidməti əlavə et',
	'Create folder': 'Qovluq yarat',
	Answer: 'Cavab',
	Price: 'Qiymət',
	'Date of creating': 'Yaradılma tarixi',
	Month: 'Ay',
	unpaid: 'Ödənilməyib',
	paid: 'Ödənilib',
	'Excluded students': 'Xaric edilmiş tələbələr',
	'Selected groups': 'Seçilmiş qruplar',
	Monday: 'Bazar ertəsi',
	Tuesday: 'Çərşənbə axşamı',
	Wensday: 'Çərşənbə',
	Thusday: 'Cümə axşamı',
	Friday: 'Cümə',
	Saturday: 'Şənbə',
	Sunday: 'Bazar günü',
	Mo: 'B.e.',
	Tu: 'Ç.a.',
	We: 'Ç.',
	Th: 'C.a.',
	Fr: 'C.',
	Sa: 'Ş.',
	Su: 'B',
	End: 'Son',
	'Add discount': 'Endirim əlavə etmək',
	Edit: 'Redaktə etmək',
	'Parent found': 'Valideyn tapılıb',
	'Changes saved': 'Dəyişikliklər saxlanııb',
	'The passwords of the parent and the student should not coincide':
		'Valideyn və tələbənin parolu uyğun olmamalıdır.',
	'Your region`s price is set to': 'Sizin regionun qiyməti ',
	'and the holder`s reward is': 'və sahibin mükafatı ',
	'regardless of the set price': 'təyin edilmiş qiymətdən asılı olmayaraq',
	'The given password is not unique for this email':
		'Verilən parol bu e-meyl üçün vahid deyil.',
	'Enter a valid email address.': 'Etibarlı e-meyl ünvanı daxil et',
	'The phone number entered is not valid':
		'Daxil edilən telefon nömrəsi etibarlı deyil',
	Holiday: 'Bayramlar',
	'Working days': 'İş günləri',
	Street: 'Küçə',
	'Location name': 'Yerin adı',
	District: 'Rayon',
	'Mental arithmetic is an oral account technique that rapidly develops the intellectual ability and intelligence of a child between 5 and 14 years of age. The training process takes place on special Japanese accountants Abaсus (Soroban). Mental arithmetic trains simultaneously the left and right hemispheres of the brain,improving visual memory,concentration of attention,creative orientation,imaginative thinking of children and their tendency to fast reading.':
		'Əqli riyaziyyat,5 ilə 14 yaş arasındakı uşağın intellektual qabiliyyətini və zəkasını sürətlə inkişaf etdirən şifahi hesablama metodudur. Tədris prosesi xüsusi Yapon hesablama alətləri  Abasus (Soroban) üzərində keçirilir. Əqli riyaziyyat,beynin sol və sağ yarımkürələri eyni vaxtda təlim etdirərək visual yaddaşı,diqqəti cəmləşdirməni,yaradıcı yanaşmanı,uşaqların xəyali düşüncə tərzini və onların sürətli oxuma meyllərini inkişaf etdirir.',
	'Field required': 'Tələb edilən sahələr',
	'Type of legal activity': 'Qanuni fəaliyyət növü',
	'Legal address': 'Hüquqi ünvan',
	'Registration number': 'Qeydiyyat nömrəsi',
	'Add Group': 'Qrup əlavə et',
	'Add Student': 'Tələbə əlavə et',
	Add: 'Əlavə et',
	'Add file': 'Fayl əlavə et',
	Signin: 'Giriş üçün imza',
	'Bonus days': 'Bonuslu günlər',
	'Bonus weeks': 'Bonuslu həftlər',
	'Are you sure you want to delete?': 'Siz silməyə əminsiniz?',
	Delete: 'Silmək',
	Days: 'Günlər',
	Confirm: 'Təsdiqləmək',
	Cancel: 'Ləğv etmək',
	Week: 'Həftə',
	Weeks: 'Həftələr',
	'Group age name': 'Əsr qrupunun adı',
	'Set bonus days': 'Bonuslu günləri təyin etmək',
	'Default language': 'Dil avtomatik seçimlə',
	'With english': 'Ingilis dili ilə',
	'Without english': 'İngilis dili olmadan',
	'Paid status': 'Ödəniş statusu',
	'Not paid': 'Ödənilməyib',
	Turnover: 'Əks üzə çevirmək',
	Block: 'Bloklamaq',
	Blocked: 'Bloklanmış',
	'On holidays': 'Tətildə',
	Language: 'Dil',
	Discounts: 'Endirim',
	Message: 'Ismarıc',
	Subject: 'Mövzu',
	Homework: 'Ev tapşırığı',
	'Homework ': 'Təlim məşqi',
	'Homework on': 'Ev tapşırığı',
	'You need to complete the exercises': 'Sizə tapşırıqları bitirmək lazımdır',
	Homework: 'Ev tapşırıqları',
	'Invoice for': 'Ödəniş üçün hesab',
	"PJSC CB 'PRIVATBANK' in Kyiv": 'PRİVATBANK ASC,Kiyevdə',
	Account: 'Hesab',
	Supplier: 'Təchizatçı',
	Buyer: 'Alıcı',
	'Bank code': 'Bank kodu ',
	'Type phone number or email':
		'Telefon nömrəsini və ya e-poçt ünvanını daxil edin',
	'Type password': 'Parol daxil edin',
	'Forgot password': 'Parolu yaddan çıxarmısınız',
	'Type your email': 'E-poçtu daxil edin',
	Send: 'Göndərin',
	'Email sent': 'Məktub göndərilib',
	'If you are signed up for the project you will receive email with the next instructions to get back access your account':
		'Layihə üçün qeydiyyatdan keçmisinizsə,hesabınıza yenidən daxil olmaq üçün növbəti talimatları elektron poçtla alacaqsınız',
	'Back to the sign in': 'Geriyə giriş səhfəsinə',
	'Password or login is not correct': 'Parol və ya giriş kodu səhvdir.',
	'Password recovery': 'Parolun bərpası',
	'Type your new password here': 'Öz yeni parolunuzu daxil edin',
	'Set new password': 'Yeni parolu yazın',
	'Learn more': 'Daha çox bilmək',
	'About Us': 'Bizim barədə',
	Company: 'Şirkət',
	Jobs: 'İşlər',
	Press: 'Mətbuat',
	'Terms of Use': 'İstiadə şərtləri',
	'Privacy Policy': 'Məxfilik siyasəti',
	'Need help?': 'Kömək lazımdır?',
	'Contact us': 'Bizimlə əlaqə saxlayın',
	'Become franchise': 'Franşiza olmaq',
	'Select language': 'Dili seçin',
	English: 'İngilis',
	Russian: 'Rus',
	New: 'Yeni',
	Azerbaijani: 'Azərbaycan',
	Ukrainian: 'Ukrayna',
	Polish: 'Polşa',
	Management: 'İdarəçilik',
	'Master Franchise': 'Franşiza üzrə magistr',
	Franchise: 'Franşiza',
	Teachers: 'Müəllimlər',
	Groups: 'Qruplar',
	Students: 'Tələbələr',
	Student: 'Tələbə',
	Parents: 'Valideyn',
	Profile: 'Profil',
	'My profile': 'Mənim profilim',
	Finance: 'Maliyyə',
	Reports: 'Hesabatlar',
	Report: 'Hesabat',
	Upload: 'Yükləmə',
	List: 'Siyahı',
	Payments: 'Ödənişlər',
	Documents: 'Sənədlər.Skan surətləri',
	Lessons: 'Dərslər',
	Materials: 'Materiallar',
	Shop: 'Mağaza',
	Statistics: 'Statistika',
	Settings: 'Qurulmalar',
	Pages: 'Səhifələr',
	Logout: 'Çıxmaq',
	Dashboard: 'Şəxsi kabinet',
	'Access denied': 'Girişə imtina edilib',
	Create: 'Yaratmaq',
	Download: 'Yükləmək',
	Status: 'Status',
	'Payment Date': 'Ödəniş tarixi',
	'Payment Amount': 'Ödəniş məbləği',
	'Start time': 'Məşğələlərə başlama vaxtı',
	'Group age': 'Qrup yaşı',
	Junior: 'Kiçiklər',
	Average: 'Ortayaşlılar',
	Class: 'Sinif',
	Older: 'Böyüklər',
	Region: 'Region',
	Group: 'Qrup',
	Person: 'Şəxs',
	Finances: 'Maliyyə',
	Actions: 'Hərəkətlər',
	'Send invoice': 'Hesab-faktura',
	'Download invoice': 'Hesabı yükləmək',
	'Send email': 'E-poçt göndərmək',
	'Create Student': 'Şagird yaratmaq',
	'The beginning of holidays': 'Tətillərin başlaması',
	'Start of study': 'Təhsilə başlama',
	'Group name': 'Qrup adı',
	'Group address': 'Qrup ünvanı',
	'Group teacher': 'Qrup müəllimi',
	'Group students': 'Qrup şagirdləri',
	'Group statistics': 'Qrup statistikası',
	Search: 'Axtarış',
	'General information': 'Ümumi informasiya',
	'Phone number': 'Telefon nömrəsi',
	'First name': 'Ad',
	Surname: 'Atasının adı',
	'Last name': 'Soyad',
	'Date of birth': 'Təvəllüd',
	Password: 'Parol',
	'Additional information': 'Əlavə informasiya',
	'Id code': 'İdentifikasiya kodu',
	Passport: 'Pasport',
	'Without email newsletter': 'e-poçtsuz xəbərlər',
	'With email newsletter': 'e-poçtlu xəbərlər',
	'Financial information': 'Maliyyə informasiyası',
	Royalty: 'Royaltı',
	'PR contribution': 'PR ödəmə',
	Currency: 'Valyuta',
	Comment: 'Şərh',
	Paid: 'Ödənilmiş',
	Invoices: 'Hesab-fakturalar',
	Bills: 'Qanunverici sənədlər',
	Acts: 'Aktlar',
	Scan: 'Skan',
	Level: 'Səviyyə',
	'Action with numbers': 'Hərəkətlər sayla',
	'Action with number': 'Əməliyyat sayı',
	'Number of expressions': 'İfadə sayı',
	'Number of expression': 'Nümunələrin sayı',
	'Imaginary abacus': 'Xəyali hesablama aləti',
	'Period report': 'Hesabat dövrü',
	City: 'Şəhər',
	'Full name franchise': 'Françizasının adı/soyadı/atasının adı',
	'Students active': 'Şagirdlər aktiv',
	'Сost of education': 'Təhsil haqqı',
	'Turnover franchise': 'Dövriyyə franşizası',
	'Discount sum': 'Endirim məbləği',
	Proprietor: 'Mülkyyətçi',
	'Additional products and services': 'Əlavə məhsul və xidmətlər',
	'Full name student': 'Şagirdin adı/soyadı/atasının adı',
	'Period of study': 'Tədris müddəti',
	'Bonus-days': 'Bonuslu günlər',
	'Amount of days': 'Günlərin sayı',
	'Total days': 'Cəmi günlər',
	'Language of instruction': 'Tədris dili',
	Teacher: 'Müəllim',
	Discount: 'Endirim',
	Remuneration: 'Haqq',
	Goods: 'Mallar',
	'Date of creation': 'Yaradılma günü',
	'Date of payment': 'Ödəniş günü',
	'Goods (works,services)': 'Mallar(işlər,xidmətlər)',
	Quantity: 'Miqdar',
	Units: 'Vahidlər',
	Amount: 'Miqdar',
	Sum: 'Cəm',
	'Sum Sub': 'Forsaj',
	Financial: 'Maliyyə',
	Additional: 'Əlavə',
	General: 'Ümumi',
	Total: 'Cəmi',
	Save: 'Yaddaşda saxlamaq',
	'Including with': 'O cümlədən',
	'Training materials': 'Tədris materialları',
	'Learning contract': 'Öyrənmə müqaviləsi',
	Games: 'Oyunlar',
	'NUMBER OF 11 TO 120': '11-120 dək RƏQƏMLƏR',
	Complexity: 'Mürəkkəblik',
	Start: 'Başlama',
	'Speedy numbers': 'Forsaj',
	Anzan: 'Anzan',
	'Abacus is random': 'Abakus nadirdir',
	Multiplication: 'Vurma',
	Division: 'Bölmə',
	Abacus: 'Abakus',
	'Multiplying by 20': '20-dək vurmaı',
	Squared: 'kvadrat köklü',
	'Division to 20': '20-dək bölmə',
	Speed: 'Sürət',
	Repeat: 'Təkrar',
	'Game type': 'Oyun tipi',
	'Digit type': 'Rəqəm tipi',
	Digit: 'Rəqəm',
	Time: 'Vaxt',
	Oral: 'Şifahi.təxayülü hesablamalar',
	Second: 'Saniyə',
	'Calculation method': 'Hesablana üsulu',
	'Only negative numbers starting with 99,999,9999 etc.,depending on the complexity of the expression: -9,-2,-3,-1 ...':
		'Yalnız 99,999,9999 başlayaraq mənfi rəqəmlər,nümunənin mürəkkəbliyindən asılı olaraq.   : -9,-2,-3,-1 ...',
	'Only subtraction': 'Yalnız çıxma',
	'Only positive numbers starting with 0. Expression: +1,+4,+6,+9,+5 ...':
		'Yalnız 0-dan balayaraq müsbət rəqəmlər .  Məsələn:  : +1,+4,+6,+9,+5 ...',
	'Only add': 'Yalnız əlavə',
	'Numbers fall randomly,starting with 0. Expression :: +3,-5,-1,+9,-2 ...':
		'Rəqəmlər 0-dan balayaraq təsadüfü düşür. Məsələn:  :: +3,-5,-1,+9,-2',
	'Random numbers': 'Təsadüfü rəqəmlər.',
	'CHOOSE COMPLEXITY:': 'MÜRƏKKƏBLİYİ SEÇİN',
	'AMOUNT OF ACTIONS WITH NUMBER': 'RƏQƏMLİ HƏRƏKƏTLƏRİN SAYI',
	FAMILY: 'AİLƏ',
	'BIG FRIENDS': 'BÖYÜK DOSTLAR',
	'LITTLE FRIENDS': 'KİÇİK DOSTLAR',
	'JUST FRIENDS': 'SADƏCƏ DOSTLAR',
	family: 'ailə',
	'big friends': 'böyük dostlar',
	'small friends': 'kiçik dostlar',
	elementary: 'sadə dostlar',
	Sound: 'Səs',
	'Congratulations! You did it! Now you can go to the following exercises':
		'Təbriklər! Siz bunu bacardınız! İndi siz aşağıdakı tapşırıqlara keçə bilərsiniz!',
	'RIGHT. ANSWER:': 'DÜZGÜN CAVAB:',
	'CORRECT:': 'DÜZGÜN',
	'NOT CORRECT': 'DÜZGÜN DEYİL',
	'Try again': 'bird aha cəhd et',
	expression: 'nümunə',
	next: 'növbəti',
	Next: 'Növbəti',
	Previous: 'Əvvəlki',
	Loading: 'Yükləmə',
	back: 'geriyə',
	Back: 'Geriyə',
	ANSWER: 'CAVAB',
	Lesson: 'Dərs',
	'History statistics': 'Statistika tarixi',
	Open: 'Açmaq',
	'Game statistics per day': 'Gün ərzində oyun statistikası',
	'Total played games': 'Cəmi oynalına oyunlar',
	'Total correct answers': 'Cəmi düzgün cavablar',
	'Total played:': 'Cəmi oynanılıb',
	Feedback: 'Geri əlaqə',
	'Leave a review': 'Rəyi bildirmək',
	'Leave us your feedback or wishes and we will definitely consider them in our work.':
		'Bizə öz təklif və arzularınızə qoyun və biz layihə üzərində işləyərkən onları mütləq nəzərə alacayıq',
	'Payment history': 'Ödənişlər tarixi',
	'Payment status': 'Ödəniş statusu',
	Pay: 'Ödəmək',
	Payer: 'Alan',
	'Getting a discount': 'Endirim almaq',
	Training: 'Təlim',
	Tasks: 'Tapşırıq',
	'Current task': 'Cari tapşırıq',
	'Only task': 'Tapşırıq',

	'Next tasks': 'Növbəti tapşırıqlar',
	'Online abacus': 'Onlayn hesablama aləti',
	'Base 50/100': 'Baza 50/100',
	multiply_base: 'Baza 50/100',
	divided: 'bölünən',
	'Do not show this instruction again': 'Bu təlimatı bir daha göstərməyin.',
	'Instructions for homework': 'Ev tapşırıqları üçün təlimatlar',
	divider: 'bölən',
	'Multiplication table': 'Vurma cədvəli',
	Restore: 'Bərpa etmək',
	Left: 'Sol',
	'Restore Hierarchy': 'İyeraxiyanı bərpa etmək',
	total: 'cəmi',
	active: 'aktiv',
	blocked: 'bloklandı',
	pageError: {
		'403': 'Giriş rədd edildi.',
		'404': 'Bu səhifə yoxdur. Yenidən cəhd edin.',
		'500': 'Server cavab vermir. Yenidən cəhd edin.',
	},
	error: {
		'Account deactivated': 'Hesabınız deaktiv edildi.',
	},
	modalNewVersion: {
		text:
			'Saytın köhnəlmiş bir versiyasından istifadə edirsiniz.\nYeniləmə artıq mövcuddur.',
		btn: 'Yeniləyin.',
	},
	games: {
		negativeNumbers: 'Mənfi ədədlər',

		pause: 'Fasilə',
		resume: 'Davam et',
		columns: {
			name: 'Sütunlar',
			users: 'Oyunçuların sayı',
			user: 'Oyunçu',
			userNames: 'Oyunçu Adları',
		},
	},
	'Indigo-dollars': 'Indigo dollar',
	Balance: 'balans',

	modalIndigoDollars: {
		submit: 'Göndərin',
		cancel: 'Ləğv et',
		title: 'Indigo dollar',
		balance: 'Cari balans',
		amount: 'Miqdarı',
		reason: 'Şərh',
	},

	modalAddNotification: {
		title: 'Bildiriş əlavə et',
		submit: 'Göndər',
		cancel: 'Ləğv et',
		empty: 'Bildiriş yoxdur',
	},

	modalTransactionsHistory: {
		title: 'Ödəniş tarixi',
		type: {
			withdraw: 'Hesabdan çıxmaq',
			deposit: 'Doldurma',
		},
		empty: 'Ödənişlərin siyahısı boşdur.',
	},

	modalCopyHomework: {
		title: 'Ev tapşırıqlarını kopyalayın',
		label: 'Ev tapşırığınızı kopyalayacağınız tarixi seçin',
		submit: 'Surəti',
		cancel: 'Ləğv et',
	},

	reportsPage: {
		history: {
			title: 'Tarixi dəyişdirin',
			empty: 'Siyahı boşdur',
			table: {
				date: 'Tarixi dəyişdirin',
				field_name: 'Fəaliyyət',
				old_value: 'Köhnə məna',
				new_value: 'Yeni dəyər',
				user: 'İstifadəçi Modified',
			},
		},
	},

	pageShop: {
		title: 'Təkmilləşdirmə Mağazası',
		description:
			'Mağazada indigo bucks üçün saytın görünüşünə dair müxtəlif inkişaflar ala bilərsiniz',

		tabs: {
			all: 'Bütün inkişaflar',
			purchased: 'Alinib',
		},

		item: {
			off_all: 'Yox',

			status: {
				AVAILABLE: 'Mövcuddur',
				DEPRECATED: 'Mövcud deyil',
				COMING_SOON: 'Tezliklə',
			},
			is_activated: 'Seçilib',
			set_active: 'Seçin',
			unset_active: 'Deaktiv edin',
			preview: 'Baxın',
			is_free: 'Pulsuzdur',
			buy: 'Alın',
			bought: 'Alınıb',
			purchased: 'Alinib',
		},
		empty: {
			all: 'Heç bir aksesuar yoxdur',
			purchased: 'Yenilənmə əldə edilməyib',
		},

		toast: {
			error: 'Bir səhv baş verdi',
			notEnoughMoney: 'Yetərsiz vəsait',
			itemBought: 'Təkmilləşdirmə satın alındı',
			itemActivated: 'Gücləndirmə aktivləşdirilib',
			itemDeactivated: 'Təkmilləşdirilmiş Deaktiv edilmişdir',
		},
		confirmPurchase: {
			title: 'Satışı təsdiqləyin',
			message: 'Bu məhsulu almaq istədiyinizə əminsiniz?',
			confirm: 'Bəli, al',
			cancel: 'Ləğv et',
		},
	},

	demo: {
		title: 'Pulsuz demo dərsi',
		tutorial: {
			title: 'Təlimat',
			text:
				'Indigo Mental klubunun zehni arifmetika üzrə onlayn demo dərsinə xoş gəlmisiniz.\nIndigo Mental - dünyanın ən yaxşı zehni arifmetika məktəbidir. Şirkətin çoxillik təcrübəsi və tələbələrimizin dünyanın bir çox ölkələrində olimpiadalarda qazandığı uğurlar bu metodikanın təsirli və bənzərsiz işlədiyini sübut edir. Bir çox valideynlər metodologiyaya çoxdan inanıb, övladlarının təkcə arifmetikada deyil, digər elmlərdə, musiqi, idman sahəsindəki uğurlarına sevinirlər və uşağının intellektual qabiliyyətlərində böyük bir sıçrayış olduğunu qeyd edirlər.\n-Zehni arifmetika - uşağın zehni qabiliyyətlərini və zəkasını sürətlə inkişaf etdirən Yapon sürətli şifahi sayma üsuludur. Tədris prosesi xüsusi Yapon abacus hesablarında (Soroban) aparılır. Zehni arifmetika beynin eyni zamanda sol və sağ yarımkürələrini, vizual yaddaşı, diqqət konsentrasiyasını, yaradıcı istiqamətləndirməni, uşaqların təsəvvürlü təfəkkürünü inkişaf etdirir.\n-Beləliklə, zehni arifmetikanı öyrənməyə başlayaq, bunun üçün aşağıdakı videodakı "PLAY" düyməsini vurun, qulaq asın və təkrarlayın.',
		},
	},

	disableStudent: {
		btn: 'Disable student',
		list: 'Students without deactivation date',
		modal: {
			title: 'Disableing a student',
			description: 'You are about to disable the student',
			fieldLabel: 'Select month',
			btnSubmit: 'Disable',
			btnCancel: 'Cancel',
		},
	},
}
